<template>
    <div class="grade-container" :class="{ selected: isSelected }">
        <div class="overlay-container-pai">
            <slot name="overlaySelecao" />
        </div>

        <div
            class="grade-layout"
            :style="{
                ...gradeStyle,
                padding: `${props.paddingTop ?? '22px'} ${props.paddingRight ?? '22px'} ${props.paddingBottom ?? '22px'} ${props.paddingLeft ?? '22px'}`,
            }"
        >
            <CelulaGrade v-for="celula in itens" :key="celula.componenteId" v-bind="celula.props" :componenteId="celula.componenteId" :cellStyle="cellStyle" />
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useEditorLandingPage } from '@/composables/useEditorLandingPage';
import CelulaGrade from './CelulaGrade.vue';

const props = defineProps({
    componenteId: {
        type: String,
        required: true,
    },
    linhas: {
        type: Number,
        default: 2,
    },
    colunas: {
        type: Number,
        default: 2,
    },
    gap: {
        type: String,
        default: '12px',
    },
    justifyItems: {
        type: String,
    },
    alignItems: {
        type: String,
    },
    paddingTop: {
        type: String,
    },
    paddingBottom: {
        type: String,
    },
    paddingLeft: {
        type: String,
    },
    paddingRight: {
        type: String,
    },
    itens: {
        type: Array,
        default: () => [],
    },
});

const { idElementoSelecionado } = useEditorLandingPage();
const isSelected = computed(() => props.componenteId === idElementoSelecionado.value);

const gradeStyle = computed(() => ({
    display: 'grid',
    gridTemplateRows: `repeat(${props.linhas}, 1fr)`,
    gridTemplateColumns: `repeat(${props.colunas}, 1fr)`,
    gap: props.gap,
    minHeight: '200px',
    padding: '22px',
}));

const cellStyle = computed(() => ({
    justifyItems: props.justifyItems,
    alignIems: props.alignItems,
}));
</script>

<style scoped lang="scss">
.grade-container {
    &.selected {
        background-color: #eaf6fb;

        :deep(.celula-grade) {
            border: 2px dashed var(--primary-color);
            background-color: #cbe7f3;
        }

        :deep(.celula-placeholder) {
            color: var(--primary-color);
        }
    }
}

.grade-container {
    :deep(.dropzone-item) {
        display: flex;
        align-items: v-bind('alignItems || "stretch"');
        justify-content: v-bind('justifyItems || "stretch"');
    }
}

.overlay-container-pai {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.overlay-container-pai :deep(.overlay-header) {
    pointer-events: auto;
}
</style>
